import React, { Component } from 'react';
import Link, { navigateTo } from 'gatsby-link';
import classnames from 'classnames';
import Helmet from 'react-helmet';
import { parse as parseQueryString } from 'qs';
import styles from './styles.module.css';

import objects from '../../../data/glassData.js';
import memories from '../../../data/memories.js';

import searchFilterAndSortGlass from '../../utils/search/glass';
import searchFilterAndSortMemories from '../../utils/search/memories';

import BackgroundContainer from '../../components/background-container';
import GridWrap from '../../components/grid-wrap';
import GridRow from '../../components/grid-row';
import GridCol from '../../components/grid-col';
import SubHeading from '../../components/sub-heading';
import ItemLink from '../../components/item-link';
import Memory from '../../components/memory';
import SiteFooter from '../../components/site-footer';

import PillButton from '../../components/pill-button';
import SearchBox from '../../components/search-box';

import RoomImage from '../../images/room.jpg';
import TileOneImage from '../../images/tile-one.jpg';
import TileTwoImage from '../../images/tile-two.jpg';

const TEXT = {
  LIMITED_RESULTS_LABEL: 'Showing only the first 4 results',
  LIMITED_RESULTS_BUTTON: 'See all results',

  SHOWING_ALL_RESULTS_LABEL: 'Found {x} results',
  SHOWING_ALL_RESULTS_BUTTON: 'See more search options',

  NO_RESULTS_LABEL: 'No results found',
  NO_RESULTS_BUTTON: 'See more search options',
};

const RESULTS_TO_SHOW = 4;

const searchGlass = searchTerm => searchFilterAndSortGlass(objects, searchTerm);
const searchMemories = searchTerm =>
  searchFilterAndSortMemories(memories, searchTerm);

const getLabelText = amountFound => {
  if (amountFound > RESULTS_TO_SHOW) {
    return TEXT.LIMITED_RESULTS_LABEL;
  } else if (amountFound > 0) {
    return TEXT.SHOWING_ALL_RESULTS_LABEL.replace('{x}', amountFound);
  } else {
    return TEXT.NO_RESULTS_LABEL;
  }
};
const getButtonText = amountFound => {
  if (amountFound > RESULTS_TO_SHOW) {
    return TEXT.LIMITED_RESULTS_BUTTON;
  } else if (amountFound > 0) {
    return TEXT.SHOWING_ALL_RESULTS_BUTTON;
  } else {
    return TEXT.NO_RESULTS_BUTTON;
  }
};

export default class Search extends Component {
  constructor(props) {
    super(props);

    const query = parseQueryString(
      typeof location !== 'undefined' &&
        location.search &&
        location.search.slice(1)
    );

    const searchTerm = query.term || '';

    this.state = {
      searchTerm,
      inUseSearchTerm: searchTerm,

      filteredGlass: searchGlass(searchTerm),
      filteredMemories: searchMemories(searchTerm),
    };
  }

  updateSearchTerm = event => {
    const value = event.target.value;
    this.setState(state => ({ searchTerm: value }));
  };

  performSearch = () => {
    ga('send', {
      hitType: 'event',
      eventCategory: 'Search',
      eventAction: 'Submit',
      eventLabel: 'searchPage',
    });
    this.setState(state => ({
      inUseSearchTerm: state.searchTerm,
      filteredGlass: searchGlass(state.searchTerm),
      filteredMemories: searchMemories(state.searchTerm),
    }));
  };

  navigateToSearch = path =>
    navigateTo(
      `/${path}?term=${encodeURIComponent(this.state.inUseSearchTerm)}`
    );

  navigateToGlassSearch = () => this.navigateToSearch('glass');
  navigateToMemorySearch = () => this.navigateToSearch('memories');

  render() {
    return (
      <div>
        <Helmet title="Search Whitefriars" />
        <div className={styles.container}>
          <BackgroundContainer src={RoomImage}>
            <GridWrap>
              <div className={styles.header}>
                <h1>Search Everything</h1>
                <SearchBox
                  value={this.state.searchTerm}
                  onChange={this.updateSearchTerm}
                  applySearchTerm={this.performSearch}
                />
              </div>
            </GridWrap>
          </BackgroundContainer>
          <GridWrap>
            <div className={styles.content}>
              <div className={styles.glassResults}>
                <SubHeading text="Glass Results" />
                <div className={styles.textAndButton}>
                  <p>{getLabelText(this.state.filteredGlass.length)}</p>
                  <PillButton
                    small
                    text={getButtonText(this.state.filteredGlass.length)}
                    onClick={this.navigateToGlassSearch}
                  />
                </div>
                <ul>
                  {this.state.filteredGlass
                    .slice(0, RESULTS_TO_SHOW)
                    .map(object => (
                      <li key={object.id}>
                        <ItemLink
                          id={object.id}
                          imageSizes="(min-width: 1200px) 244px, (min-width: 1024px) calc(25vw - 2.75rem), (min-width: 768px) calc(50vw - 5rem), calc(100vw - 4rem)"
                        />
                      </li>
                    ))}
                </ul>
              </div>

              <div className={styles.memoryResults}>
                <SubHeading text="Memory Results" />
                <div className={styles.textAndButton}>
                  <p>{getLabelText(this.state.filteredMemories.length)}</p>
                  <PillButton
                    small
                    text={getButtonText(this.state.filteredMemories.length)}
                    onClick={this.navigateToMemorySearch}
                  />
                </div>
                <ul>
                  {this.state.filteredMemories
                    .slice(0, RESULTS_TO_SHOW)
                    .map(memoryDetails => (
                      <li key={memoryDetails.submissionDate}>
                        <Memory {...memoryDetails} />
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </GridWrap>
        </div>
        <SiteFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/search/index.js